import { COLORS as C, MONO, RADIUS } from "../../constants/ui";

/**
 * The pill tab group from Tracker's wall.
 *
 * Nine different tab implementations existed across the app, no two alike —
 * some inverted (white pill on grey), some gradient, some MUI. This is the one
 * shape: a bordered white container, the selected tab filled with the accent,
 * and a monospaced count chip so the numbers line up.
 *
 * tabs: [{ key, label, count?, tone? }]  — tone "warn" for states that should
 * read as needing attention.
 */
export default function TabGroup({ tabs = [], value, onChange, style }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        background: C.surface,
        border: `1px solid ${C.line}`,
        borderRadius: RADIUS.card,
        padding: 5,
        width: "fit-content",
        maxWidth: "100%",
        ...style,
      }}
    >
      {tabs.map((tab) => {
        const selected = value === tab.key;
        const warn = tab.tone === "warn";
        return (
          <button
            key={tab.key}
            onClick={() => onChange?.(tab.key)}
            aria-pressed={selected}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 14px",
              borderRadius: RADIUS.control,
              border: "none",
              cursor: "pointer",
              fontSize: "0.8rem",
              fontWeight: 700,
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              background: selected ? (warn ? C.warn : C.accent) : "transparent",
              color: selected ? "#fff" : warn ? C.warn : C.inkSoft,
            }}
          >
            {tab.label}
            {tab.count != null ? (
              <span
                style={{
                  fontFamily: MONO,
                  fontSize: "0.7rem",
                  padding: "1px 7px",
                  borderRadius: RADIUS.pill,
                  minWidth: 20,
                  textAlign: "center",
                  background: selected ? "rgba(255,255,255,0.22)" : warn ? C.warnSoft : C.sunken,
                  color: selected ? "#fff" : warn ? C.warn : C.inkFaint,
                }}
              >
                {tab.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
